import {
  Component,
  Input,
  Output,
  EventEmitter,
  ViewChild,
  OnInit,
  OnChanges,
  SimpleChanges,
  ElementRef
} from '@angular/core';
import { ModalComponent } from 'core/components/modal/modal.component';
import { ItinerariesService } from 'core/services';
import { Itinerary } from 'core/models';
import { ItineraryTranslationsListService, translationsLangs } from './itinerary-translations-list.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'lms-itinerary-translations-list',
  templateUrl: './itinerary-translations-list.component.html',
  styleUrls: ['./itinerary-translations-list.component.scss'],
  providers: [ItineraryTranslationsListService]
})
export class ItineraryTranslationsListComponent implements OnInit, OnChanges {
  @Input() translations: any[];
  @Input() itinerary: Itinerary;
  @Output() onSelect = new EventEmitter<any>();
  @Output() onUpdateTranslations = new EventEmitter<any>();

  @ViewChild('translationsTable', { static: false }) public translationsTable: ElementRef;
  @ViewChild('modalLangDelete', { static: false }) public modalLangDelete: ModalComponent;

  public dataSource: any;
  public selectedTranslations: any[] = [];
  public listId = 'ITINERARY_TRANSLATIONS_LIST';
  public listOptions = {
    disableHandler: (data) => this.disableHandler(data),
    selectionHandler: (data) => this.selectionHandler(data)
  };

  constructor(
    public translate: TranslateService,
    public itinerariesService: ItinerariesService,
    public translationsListService: ItineraryTranslationsListService
  ) {}

  ngOnInit(): void {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.translations.currentValue) {
      this.dataSource = this.translationsListService.getDatasource(this.listId, this.listOptions, this.translations);
    }
  }

  selectionHandler(rowData) {
    if (rowData && rowData.lang !== this.itinerary.lang) {
      return this.selectedTranslations.some((translation) => translation.lang === rowData.lang);
    }
    return false;
  }

  disableHandler(rowData) {
    return rowData && rowData.lang === this.itinerary.lang ? true : false;
  }

  onSelectionChanged(selectedTranslations) {
    this.selectedTranslations = selectedTranslations.filter((translation) => translation.lang !== this.itinerary.lang);
  }

  cancelSelection() {
    this.selectedTranslations = [];
    this.translationsTable.nativeElement.setAllSelected(false);
  }

  selectTranslation(lang?) {
    if (lang && lang === this.itinerary.lang) return;
    this.onSelect.emit(lang);
  }

  deleteLang() {
    this.modalLangDelete.open();
  }

  confirmDelete() {
    this.selectedTranslations.forEach((translation) => {
      this.itinerariesService
        .deleteItineraryTranslation(this.itinerary.id, translation.lang)
        .then((updatedTranslation: any) => {
          this.onUpdateTranslations.emit(updatedTranslation);
        });
    });
    this.modalLangDelete.close();
  }

  get deleteMessage() {
    const LangName = this.selectedTranslations
      ? this.selectedTranslations
          .map((translation) => {
            switch (translation.lang) {
              case 'es':
                return this.translate.instant('languages.spanish');
              case 'fr':
                return this.translate.instant('languages.french');
              case 'de':
                return this.translate.instant('languages.german');
              case 'pt':
                return this.translate.instant('languages.portuguese');
              case 'nl':
                return this.translate.instant('languages.dutch');
              case 'en':
              default:
                return this.translate.instant('languages.english');
            }
          })
          .join(', ')
      : '';
    return this.translate.instant('itineraries.notification.langSelectedDelete', {
      LangName
    });
  }

  get isAllTranslated() {
    return this.translations.length === Object.keys(translationsLangs).length;
  }
}
